import DressupCharacter from '@/objects/dressupCharacter';
import ItemCarousel from '../objects/itemCarousel';
import CharacterItem from '@/objects/CharacterItem';
import XyloButton from '../objects/xyloButton';
import BaseScene from '../objects/baseScene';
import SimpleButton from '../objects/simpleButton';

export default class Dressup extends BaseScene {

  constructor() {
    super({
      key: 'Dressup'
    });
  }

  /**
   *  Called when a scene is initialized. Method responsible for setting up
   *  the game objects of the scene.
   *
   *  @protected
   *  @param {object} data Initialization parameters.
   */

  init(data) {
    super.init(data);
    this.characterID = data.characterID;
    this.freezeTime = data.freezeTime;
    this.freezeAnim = data.freezeAnim;

  }

  create() {
    super.create();
    let charData = this.cache.json.get('data').characters;
    this.dressupData = this.cache.json.get('data').dressupConfig;
    console.log(this.dressupData);
    this.characterSFX = this.cache.json.get('data').characterSFX;
    let x = this.screenWidth;
    let y = this.screenHeight;
    this.bg.setTexture(charData[this.characterID].bg);
    this.bg.setOrigin(0.5, 0.5);
    this.bg.setDisplaySize(x, y);
    this.bg.setDepth(-5);
    this.carouselGroup = this.add.group();
    this.itemScale = this.dressupData.itemScale;
    this.worldScale = charData[this.characterID].dressupScale;
    this.dressItems = this.dressupData.items;
    this.activeSlots = [];
    this.placedItems = [];
    let id = this.characterID;
    let c = new DressupCharacter(
      this,
      id,
      charData[id].spine, // the key of the object in cache
      charData[id].skin,
      charData[id].animations,
      charData[id].sfx,
      charData[id].slots
    );

    c.setTransform(
      x * 0.5, // X positon
      y * 0.85, // Y position
      charData[id].scale * this.dressupData.scaleX * this.worldScale * charData[id].direction,
      charData[id].scale * this.worldScale * this.dressupData.scaleY,
      1
    );
    c.emitter.on('characterClicked', this.checkForItems, this);
    c.toggleEyes(true);

    this.itemSfxTrigger = 3;
    this.itemCount = 0;
    this.idleSFXIndex = 0;
    this.canPlaySFX = true;
    this.idleSFX = [];
    let idleVO = [];
    let idleSounds = [];
    for (let j = 0; j < this.characterSFX.length; j++) {
      let charSFX = this.characterSFX[j];
      if (charData[id].sfxPath !== charSFX.name) {
        for (let k = 0; k < charSFX.sounds.length; k++) {
          idleSounds.push(charSFX.sounds[k]);
        }
        for (let k = 0; k < charSFX.vo[window.language].length; k++) {
          idleVO.push(charSFX.vo[window.language][k]);
        }
      } else {
        if (charSFX.include !== undefined) {
          for (let k = 0; k < charSFX.include[window.language].length; k++) {
            idleVO.push(charSFX.include[window.language][k]);
          }
        }
      }
    }

    idleVO.sort(() => Math.random() - 0.5);
    idleSounds.sort(() => Math.random() - 0.5);
    let voIdx = 0;
    for (let k = 0; k < idleSounds.length; k++) {
      if (k % 2 == 0) {
        if(idleVO[voIdx] !== undefined)
        {
          this.idleSFX.push(idleVO[voIdx]);
        }
        voIdx = (voIdx + 1) % idleVO.length;
      }
      this.idleSFX.push(idleSounds[k]);
    }

    this.charRect = c.clickArea.getBounds();
    this.character = c;
    // this.xyloButton = new XyloButton(
    //   this,
    //   x / 2,
    //   y - 10,
    //   () => this.handleXyloButtonDown(),
    //   true,
    //   false,
    //   this.uiGroup
    // );
    this.tickBtn = new SimpleButton(this, x - 80, y - 80, 'tickBtn', () =>
      this.handlePlayButtonDown()
    );

    this.carousel = new ItemCarousel(
      this,
      'carousel',
      80,
      0,
      320,
      y,
      this.dressItems,
      this.dressupData.maxItems,
      this.dressupData.padding,
      0.45 * this.dressupData.scaleX,
      this.worldScale,
      this.dressupData.itemScale
    );
    this.carousel.emitter.on('itemReleased', this.handleItemReleased, this);
    this.carouselGroup.add(this.carousel);
    this.character.freeze(this, this.freezeAnim, this.freezeTime);
    this.itemGroup = this.add.group();
    /* this.setupInputEvents(); */
  }

  /*  setupInputEvents() {
     this.input.on(
       'dragstart',
       function (pointer, gameObject) {
         let dist = 1000;
         for (let i = 0; i < this.itemGroup.length; i++) {
           let item = this.itemGroup.getAt(i);
           let width = item.width / 2;
           let height = item.height / 2;
           let x = item.x - pointer.x;
           let y = item.y - pointer.y;
           let itemDist = x * x + y * y;
           console.log('itemDistance --> ' + itemDist + '/' + dist);
           if (itemDist < dist && (pointer.x >= item.x - width && pointer.x <= item.x + width &&
             pointer.y >= item.y - height && pointer.y <= item.y + height)) {
             item.itemDraggable = true;
             item.sqrDragDist = 0;
             dist = itemDist;
             this.draggingItem = item;
           }
         }
       }
       ,
       this
     );
 
     this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
       if (this.draggingItem !== undefined && this.draggingItem.itemDraggable === true) {
         let x = this.draggingItem.x - dragX;
         let y = this.draggingItem.y - dragY;
         this.draggingItem.sqrDragDist += x * x + y * y;
         this.draggingItem.x = dragX;
         this.draggingItem.y = dragY;
       }
     });
 
     this.input.on(
       'dragend',
       function (pointer, gameObject) {
         if (this.draggingItem !== undefined && this.draggingItem.itemDraggable) {
           this.draggingItem.itemDraggable = false;
           this.draggingItem.emitter.emit('touchUp', pointer, this);
           this.draggingItem = undefined;
         }
       },
       this
     );
   } */

  handlePaused() {
    super.handlePaused();
    this.tickBtn.blocked = true;
    this.carousel.toggleBlocked(true);
  }

  handleResumed() {
    super.handleResumed();
    this.tickBtn.blocked = false;
    this.carousel.toggleBlocked(false);
  }

  checkForItems(id, pointer) {
    let x = pointer.x;
    let y = pointer.y;
    let slot = this.character.getSlotFromPosition(x, y);
    if (slot !== null) {
      if (Array.isArray(slot)) {
        for (let i = 0; i < slot.length; i++) {
          this.setAttachment(null, slot[i], null);
        }
      } else {
        this.setAttachment(null, slot, null);
      }
    }
  }


  handleXyloButtonDown() {
    // eslint-disable-next-line no-console
    // console.log('Clicked!');
    this.scene.start('CharacterSelect', {
      characterID: this.characterID,
      activeSlots: this.activeSlots,
      placedItems: this.placedItems,
      freezeAnim: this.freezeAnim,
      freezeTime: this.freezeTime,
      mute: this.mute
    });
    this.cleanup();
  }

  handlePlayButtonDown() {
    this.scene.start('CharacterSelect', {
      characterID: this.characterID,
      activeSlots: this.activeSlots,
      placedItems: this.placedItems,
      freezeAnim: this.freezeAnim,
      freezeTime: this.freezeTime,
      mute: this.mute
    });
    this.time.delayedCall(100, this.cleanup);
  }

  handleItemReleased(pointer, item) {
    let itemDef = this.dressItems[item.itemID];
    let inBounds = this.pointInBounds(this.charRect, pointer);
    if (inBounds || item.sqrDragDist <= 5) {
      // item.toggleInteractive(this, false);
      // this.placedItems.push(item);
      this.onItemPlaced();
      if (itemDef.type === 'spine') {
        if (itemDef.slots !== undefined) {
          for (let i = 0; i < itemDef.slots.length; i++) {
            this.setAttachment(itemDef.icon, itemDef.slots[i], itemDef.regions[i], itemDef.overrideSlot);
          }
        } else {
          this.setAttachment(itemDef.icon, itemDef.slot, itemDef.region);
        }
      } else {
        let tapped = item.sqrDragDist <= 5;
        var itemX = pointer.x;
        var itemY = pointer.y;
        if (tapped) {
          var itemPos = this.character.randomPointInBounds();
          itemX = itemPos.x;
          itemY = itemPos.y;
        }
        this.addSprite(itemDef.icon, item.itemID, itemX, itemY, 0.65);
      }
    }
    // else {
    item.returnToCarousel();
    // }
  }

  onItemPlaced() {
    this.sound.play('pop');
    this.itemCount++;
    if (this.itemCount >= this.itemSfxTrigger && this.canPlaySFX) {
      this.itemCount = 0;
      console.log(this.idleSFX);
      this.sound.play(this.idleSFX[this.idleSFXIndex]);
      this.idleSFXIndex ++; 
      if(this.idleSFXIndex >= this.idleSFX.length)
      {
        this.idleSFXIndex = 0;
      }
      //= (this.idleSFXIndex + 1) % (this.idleSFX.length);
      this.canPlaySFX = false;
      this.time.delayedCall(2000, () => this.onSfxAvailable(), this);
    }
  }

  onSfxAvailable() {
    this.canPlaySFX = true;
  }

  setAttachment(newSprite, newSlot, newAttachment, overrideSlot) {
    this.character.setAttachment(newSlot, newAttachment);
    if (this.activeSlots.length > 0) {
      for (var i = 0; i < this.activeSlots.length; i++) {
        if (this.activeSlots[i].slot === newSlot) {
          if (newAttachment !== null) {
            this.activeSlots[i].item = newSprite;
            this.activeSlots[i].attachment = newAttachment;
            if (overrideSlot !== undefined) {
              this.activeSlots[i].overrideSlot.noSprite = overrideSlot.slot !== newSlot;
              this.activeSlots[i].overrideSlot.spriteName = overrideSlot.sprite;
            }
            return;
          } else {
            this.activeSlots.splice(i, 1);
            return;
          }
        }
      }
    }

    if (overrideSlot !== undefined) {
      this.activeSlots.push({
        slot: newSlot,
        item: newSprite,
        attachment: newAttachment,
        overrideSlot: {
          noSprite: newSlot !== overrideSlot.slot,
          spriteName: overrideSlot.sprite
        }
      });
    } else {
      this.activeSlots.push({
        slot: newSlot,
        item: newSprite,
        attachment: newAttachment
      });
    }
  }

  addSprite(newSprite, id, newX, newY) {
    // console.log(newX + ', ' + newY + ' --> ');
    // console.log(normPos);
    var normPos = this.character.getNormalizedPosition(newX, newY);
    let thisID = Math.round(Date.now() * Math.random());
    let scale = this.worldScale * this.dressupData.itemScale;
    console.log('dressup item scale --> ' + scale);
    let sprite = new CharacterItem(this, newX, newY, newSprite, id, thisID, scale);
    sprite.emitter.on('touchUp', this.spriteReleased, this);
    sprite.toggleInteractive(this, true);
    sprite.freePlace = true;
    this.character.addItem(this, sprite);
    this.placedItems.push({
      sprite: newSprite,
      objID: thisID,
      x: normPos.x,
      y: normPos.y
    });
    this.itemGroup.add(sprite);
    if (this.placedItems.length >= 20) {
      var items = this.itemGroup.getChildren();
      let item = items[0];
      item.destroy();
      item = null;
      // this.itemGroup.remove(1, this.placedItems.length - 1);
      this.placedItems.shift();
    }
  }

  spriteReleased(pointer, sprite) {
    let inBounds = this.pointInBounds(this.charRect, pointer);
    if (inBounds == false) {
      this.tweens.add({
        targets: sprite,
        displayWidth: 0,
        duration: 200,
        ease: 'Back.easeIn',
        onEnd: () => {
          let thisID = sprite.objID;
          for (var i = 0; i < this.placedItems.length; i++) {
            let placedID = this.placedItems[i].objID;
            if (placedID == thisID) {
              this.itemGroup.remove(i);
              this.placedItems.splice(i, 1);
              sprite.destroy();
              return;
            }
          }
        }
      });
    } else {
      console.log(sprite.objID + ' repositioned');
      let newPos = { x: sprite.x, y: sprite.y };//{x: pointer.x, y: pointer.y }
      var normPos = this.character.getNormalizedPosition(newPos.x, newPos.y);
      let thisID = sprite.objID;
      for (var i = 0; i < this.placedItems.length; i++) {
        let placedID = this.placedItems[i].objID;
        if (placedID == thisID) {
          this.placedItems[i].x = normPos.x;
          this.placedItems[i].y = normPos.y;
          return;
        }
      }
    }
  }

  pointInBounds(bounds, pointer) {
    let x = pointer.x;
    let y = pointer.y;
    let minX = bounds.x;
    let minY = bounds.y;
    let maxX = bounds.x + bounds.width;
    let maxY = bounds.y + bounds.height;
    if (x < minX || x > maxX) {
      return false;
    } else if (y < minY || y > maxY) {
      return false;
    } else {
      return true;
    }
  }

  cleanup() {
    this.character.destroy();
    this.character = null;
    this.carousel.destroy();
    this.carousel = null;
    // this.xyloButton.destroy();
    // this.xyloButton = null;

    this.tickBtn.destroy();
    this.tickBtn = null;

    this.carouselGroup.clear(true);
    this.carouselGroup.destroy();
    this.carouselGroup = null;
    this.itemGroup.clear(true);
    this.itemGroup.destroy();
    this.itemGroup = null;
    this.activeSlots = null;
    this.placedItems = null;
    this.dressItems = null;
    this.dressupData = null;
    super.cleanup();
  }
}
